import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { ToastProvider } from './components/Toast.jsx'
import App from './App.jsx'
import { noteSigninReturn } from './lib/signinPage.js'
import './styles.css'

// Before the router reads the address: a full-page sign-in's answer comes back on it.
noteSigninReturn()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: true, retry: false, staleTime: 10_000 },
  },
})

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          {/* Inside the router so a toast survives navigation, outside App so every screen
              — including the ones rendered before sign-in — can raise one. */}
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
